'use client';

import { c as _c } from "react/compiler-runtime";
import { ReactNode, useRef } from 'react';
import { Button } from '@material-bank/mb3-components';
import { ArrowLeftIcon } from '@material-bank/mtag-icons';
import { StepIntro } from '@material-bank/mtag-ui-components';
import type { LoginStep as LoginStepType } from '../../PasswordlessLogin/PasswordlessLogin';
import { usePasswordlessLogin } from '../../PasswordlessLogin/usePasswordlessLogin';
import { DialogEmailStep } from './DialogEmailStep';
import { DialogOtpStep } from './DialogOtpStep';
import { LoginStepStepper } from './LoginStepStepper';
import { useKeepSheetAboveKeyboard } from '../../../hooks/useKeepSheetAboveKeyboard';
export type LoginIntro = {
  title: string;
  icon: ReactNode;
  description?: string;
};
type LoginStepProps = {
  step: LoginStepType;
  // Shown in place of the back button and stepper on the email step, when the
  // sheet opens straight onto the email field.
  intro?: LoginIntro;
  onBack: () => void;
  onSuccess: () => void;
  onStepChange: (step: LoginStepType) => void;
};
export function LoginStep(t0) {
  const $ = _c(35);
  const {
    step,
    intro,
    onBack,
    onSuccess,
    onStepChange
  } = t0;
  let t1;
  if ($[0] !== onStepChange || $[1] !== onSuccess) {
    t1 = {
      onSuccess,
      onStepChange
    };
    $[0] = onStepChange;
    $[1] = onSuccess;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    email,
    isLoading,
    emailError,
    otpError,
    emailSubmitHandler,
    otpSubmitHandler,
    resendHandler
  } = usePasswordlessLogin(t1);
  const rootRef = useRef(null);
  useKeepSheetAboveKeyboard(rootRef);
  if (intro && step === "email") {
    let t2;
    if ($[3] !== intro.description || $[4] !== intro.icon || $[5] !== intro.title) {
      t2 = <div className="flex flex-col items-center gap-4 pt-3"><StepIntro title={intro.title} icon={intro.icon} description={intro.description} /></div>;
      $[3] = intro.description;
      $[4] = intro.icon;
      $[5] = intro.title;
      $[6] = t2;
    } else {
      t2 = $[6];
    }
    let t3;
    if ($[7] !== emailError || $[8] !== emailSubmitHandler || $[9] !== isLoading) {
      t3 = <DialogEmailStep variant="intro" isLoading={isLoading} error={emailError} onSubmit={emailSubmitHandler} />;
      $[7] = emailError;
      $[8] = emailSubmitHandler;
      $[9] = isLoading;
      $[10] = t3;
    } else {
      t3 = $[10];
    }
    let t4;
    if ($[11] !== t2 || $[12] !== t3) {
      t4 = <div ref={rootRef} className="flex flex-col gap-6">{t2}{t3}</div>;
      $[11] = t2;
      $[12] = t3;
      $[13] = t4;
    } else {
      t4 = $[13];
    }
    return t4;
  }
  let t2;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <ArrowLeftIcon />;
    $[14] = t2;
  } else {
    t2 = $[14];
  }
  let t3;
  if ($[15] !== onBack) {
    t3 = <Button type="button" size="icon" variant="secondary" data-haptic="light" onClick={onBack}>{t2}</Button>;
    $[15] = onBack;
    $[16] = t3;
  } else {
    t3 = $[16];
  }
  let t4;
  if ($[17] !== step) {
    t4 = <div className="flex-1"><LoginStepStepper step={step} /></div>;
    $[17] = step;
    $[18] = t4;
  } else {
    t4 = $[18];
  }
  let t5;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <span className="w-12" />;
    $[19] = t5;
  } else {
    t5 = $[19];
  }
  let t6;
  if ($[20] !== t3 || $[21] !== t4) {
    t6 = <div className="flex items-center">{t3}{t4}{t5}</div>;
    $[20] = t3;
    $[21] = t4;
    $[22] = t6;
  } else {
    t6 = $[22];
  }
  let t7;
  if ($[23] !== email || $[24] !== emailError || $[25] !== emailSubmitHandler || $[26] !== isLoading || $[27] !== otpError || $[28] !== otpSubmitHandler || $[29] !== resendHandler || $[30] !== step) {
    t7 = step === "otp" ? <DialogOtpStep email={email} isLoading={isLoading} error={otpError} onSubmit={otpSubmitHandler} onResend={resendHandler} /> : <DialogEmailStep isLoading={isLoading} error={emailError} onSubmit={emailSubmitHandler} />;
    $[23] = email;
    $[24] = emailError;
    $[25] = emailSubmitHandler;
    $[26] = isLoading;
    $[27] = otpError;
    $[28] = otpSubmitHandler;
    $[29] = resendHandler;
    $[30] = step;
    $[31] = t7;
  } else {
    t7 = $[31];
  }
  let t8;
  if ($[32] !== t6 || $[33] !== t7) {
    t8 = <div ref={rootRef} className="flex flex-col gap-6">{t6}{t7}</div>;
    $[32] = t6;
    $[33] = t7;
    $[34] = t8;
  } else {
    t8 = $[34];
  }
  return t8;
}